import { JobAzCheckWageCalculationStep } from '@agent-ds/shared/interfaces';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'ag-wage-az-check-calculation-steps',
  templateUrl: './wage-az-check-calculation-steps.component.html',
  styleUrls: ['./wage-az-check-calculation-steps.component.scss'],
})
export class WageAzCheckCalculationStepsComponent {
  @Input() title = '';
  @Input() steps: JobAzCheckWageCalculationStep[] = [];
}
